export function getBaseUrl(): string {
  if (process.env.API_ENV === 'production' || !process.env.API_ENV)
    return 'https://api.flex-appeal.nl';
  if (process.env.API_ENV === 'local')
    return 'http://localhost:8000';
  return `https://api.flex-appeal-${process.env.API_ENV}.dev`;
}

export const BASE_URL = getBaseUrl();
